import React from 'react'
import { CoinRow } from './CoinRow';

const titles = ['#', 'Name', 'Price', '24h %', 'Volume (24h)', 'Market Cap', 'Circ. Supply', ' Max Supply'];

export const TableCoins = ({coins, search, darkmode}) => {
    const filteredCoins = coins.filter(
        (coin) => 
            coin.name.toLowerCase().includes(search.toLowerCase()) ||
            coin.symbol.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className={`table-container ${darkmode ? 'dark' : ''}`}>
            <div className="table-responsive">
                <table className={`coins-table ${darkmode ? "dark" : "light"}`}>
                    <thead>
                        <tr>
                            {
                                titles.map((title, index) => (
                                    <th key={index} className="table-header">{title}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {filteredCoins.length === 0 ? (
                            <tr>
                                <td colSpan={titles.length} className="no-results">
                                    <div className="no-results-content">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="8"></circle>
                                            <path d="m21 21-4.35-4.35"></path>
                                        </svg>
                                        <p>No se encontraron monedas</p>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredCoins.map((coin, index) => (
                                <CoinRow coin={coin} key={coin.id || index} index={index + 1} darkmode={darkmode}/>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default TableCoins